<template>
  <div class="content-panel">
    <a-input-search
      v-model="searchName"
      style="margin-bottom: 8px"
      placeholder="请输入设备特性名称"
      @search="getTreeData(true)"
      @pressEnter="getTreeData(true)"
      v-if="showSearch"
    />
    <a-button type="primary" style="width: 100%;margin-bottom: 8px;" @click="addDeviceType()" v-if="$auth('featureManagement.add')">新增特性</a-button>
    <a-spin :spinning="loading" wrapperClassName="deviceTypeSpin">
      <a-card :bordered="false">
        <a-tree
          style="height:100%"
          v-if="treeData.length > 0"
          :treeData="treeData"
          @expand="onExpand"
          @select="onSelect"
          :draggable="true"
          @drop="onDrop"
          :showIcon="false"
          :selectedKeys="selectedKeys"
          defaultExpandAll
        >
          <template slot="custom" slot-scope="item">
            <a-tooltip placement="topLeft" :title="item.name">
              <div class="treeCompanyName">{{ item.name }}</div>
            </a-tooltip>
            <div class="icon-panel">
              <a-tooltip style="margin-left: 10px" v-if="$auth('featureManagement.add')">
                <template slot="title">
                  新增
                </template>
                <a-icon @click.stop="addDeviceType(item)" type="plus" />
              </a-tooltip>
              <a-popconfirm
                placement="topLeft"
                title="确定要删除吗"
                @confirm="e => delDeviceType(item)"
                style="margin-left: 10px"
              >
                <a-tooltip v-if="$auth('featureManagement.del')">
                  <template slot="title">
                    删除
                  </template>
                  <a-icon v-if="$auth('deviceType.del')" style="color:red;" type="delete" />
                </a-tooltip>
              </a-popconfirm>
            </div>
          </template>
        </a-tree>
      </a-card>
    </a-spin>
  </div>
</template>
<script>
import { delDeviceType, dragDeviceType } from '@/api/deviceType'
import { delEquipmentParameters, dragEquipmentParameters, getEquipmentTree } from '@/api/featureManagement'
export default {
  name: 'OrgTree',
  components: {
  },
  props: ['isOut', 'showSearch'],
  data () {
    return {
      expandedKeys: [],
      loading: false,
      searchName: '',
      treeData: [],
      defaultSelectedKeys: [],
      selectedKeys: [],
      uniqueValue: 0,
      beforeSelectData: {}
    }
  },
  beforeCreate () {
    this.form = this.$form.createForm(this, { name: 'dept_form' })
  },
  created () {
    // 获取使用部门
    this.getTreeData(true)
  },
  methods: {
    // 获取设备树
    getTreeData (resetSelectedKeys) {
      this.loading = true
      const data = { name: this.searchName.trim() }
      getEquipmentTree(data).then(res => {
        if (res.status === 0) {
          this.loop(res.data)
          this.treeData = res.data
          if (res.data[0]) {
            if (resetSelectedKeys) {
              this.selectedKeys = [res.data[0].key]
              this.initTable(res.data[0])
            }
          } else {
            this.initTable()
          }
        } else {
          this.$message.error(res.info.message)
        }
        this.loading = false
      })
    },
    loop (data) {
      for (let i = 0; i < data.length; i++) {
        data[i].scopedSlots = {
          title: 'custom'
        }
        if (data[i].children) {
          this.loop(data[i].children)
        }
      }
    },
    // 初始化 编辑或新增表格
    initTable (data) {
      if (!data) {
        this.addDeviceType()
        return
      }
      this.$store.commit('setSelectFeatureTreeId', {
        type: 'edit',
        data: {
          id: data.id,
          pName: data.name
        },
        uniqueValue: this.uniqueValue++
      })
    },
    // 新增 新增表格
    addDeviceType (data) {
      if (data) {
        this.selectedKeys = [data.id]
        this.$store.commit('setSelectFeatureTreeId', {
          type: 'addChildren',
          data: {
            id: data.id,
            pName: data.name
          },
          uniqueValue: this.uniqueValue++
        })
      } else {
        this.selectedKeys = []
        this.$store.commit('setSelectFeatureTreeId', {
          type: 'add',
          uniqueValue: this.uniqueValue++
        })
      }
    },
    // 选中 编辑表格
    onSelect (selectKeys, e) {
      if (e.selectedNodes[0]) {
        const data = e.selectedNodes[0].data.props
        this.beforeSelectData = data
        this.selectedKeys = selectKeys
      }
      this.$store.commit('setSelectFeatureTreeId', {
        type: 'edit',
        data: this.beforeSelectData,
        uniqueValue: this.uniqueValue++
      })
    },
    // 删除按钮
    async delDeviceType (e, forceDelete) {
      if (e.children.length > 0) {
        this.$message.warning('该设备类型存在子节点，不允许删除')
        return
      }
      const data = {
        'id': e.id,
        'forceDelete': forceDelete
      }
      delEquipmentParameters(data).then(res => {
        if (res.status === 0) {
          this.$message.success(res.info.message)
          this.getTreeData()
        } else if (res.status === 5002) {
          this.showDeleteConfirm(e, res.info.message)
        } else {
          this.$message.error(res.info.message)
        }
      })
    },
    // 提示
    showDeleteConfirm (e, message) {
      const that = this
      this.$confirm({
        title: message,
        okText: '确定',
        okType: 'primary',
        cancelButtonProps: { style: { display: 'none' } }, // 隐藏取消按钮
        onOk () {
        },
        onCancel () {
        }
      })
    },
    // 展开
    onExpand (expandedKeys) {
      this.expandedKeys = expandedKeys
    },
    // 拖拽
    onDrop (info) {
      console.log(info)
      const vm = this
      var realPos, query
      const dropKey = info.node.eventKey
      const dragKey = info.dragNode.eventKey
      const dropPos = info.node.pos.split('-')
      const dragPos = info.dragNode.pos.split('-')
      const dropPosition = info.dropPosition - Number(dropPos[dropPos.length - 1])
      if (dragPos.length === dropPos.length && dragPos[dragPos.length - 2] === dropPos[dropPos.length - 2]) {
        if (dropPosition === -1) {
          realPos = Number(dropPos[dropPos.length - 1]) + 1
        } else {
          realPos = Number(dropPos[dropPos.length - 1]) + 2
        }
        if (Number(dragPos[dragPos.length - 1]) < Number(dropPos[dropPos.length - 1])) {
          realPos = realPos - 1
        }
      } else {
        if (dropPosition === -1) {
          realPos = info.dropPosition + 2
        } else {
          realPos = info.dropPosition + 1
        }
      }

      query = {
        id: dragKey,
        pid: dropPosition === 0 ? dropKey : info.node.dataRef.pid,
        position: realPos
      }
      let showTitle = ''
      if (dropPosition === 0) {
        console.log('长度', info.node.dataRef.children.length)
        const childPos = info.node.dataRef.children.length + 1
        query.position = childPos

        showTitle = `您确定修改【${info.dragNode.dataRef.name}】的父节点为【${info.node.dataRef.name}】并调整顺序为第【${childPos}】位吗?`
      } else {
        showTitle = `您确定修改【${info.dragNode.dataRef.name}】的父节点为【${info.node.dataRef.pName ||
          '一级设备类型'}】并调整顺序为第【${query.position}】位吗?`
      }

      this.$confirm({
        title: showTitle,
        onOk () {
          return new Promise(async (resolve, reject) => {
            await vm.Drop(info, query)
            resolve()
          }).catch(() => console.log('errors!'))
        },
        onCancel () {}
      })
    },
    // 字典拖拽
    async Drop (info, query) {
      console.log(query)
      // return
      dragEquipmentParameters(query).then(res => {
        if (res.status === 0) {
          this.$message.success('操作成功!')
          // 拖拽完后重新获取树信息(因为sort值已经改变)
          this.getTreeData()
        } else {
          this.$message.error(res.info.message)
        }
      })
    }
  }
}
</script>
<style lang="less">
.ant-modal-body {
  #chart-container {
    overflow-x: auto;
  }
}

.ant-tooltip {
  z-index: 1020;
}
.content-panel {
  height: 100%;
  .action-btn-line {
    display: flex;
    justify-content: space-between;
  }

  .ant-tree-title {
    width: 100%;
    position: relative;
    & > span {
      // width: 90px;
      display: inline-block;
      white-space: pre-line !important;
    }
  }
  .title {
    float: left;
  }

  .ant-card-body {
    padding: 0;

    :global {
      .ant-tree {
        line-height: 3;

        .ant-tree-node-content-wrapper,
        .ant-tree-switcher {
          height: auto;
          margin-top: 5px;
          margin-bottom: 5px;
        }
        .ant-tree-switcher_close{
          background: url('../../../../src/assets/icon-close.svg') no-repeat 5px 4px !important;
          svg{
            display: none !important;
          }
        }
        .ant-tree-node-content-wrapper:hover {
          background: transparent;
        }
        .ant-tree-treenode-selected {
          background: #e6f7ff;
          height: auto !important;
          .ant-tree-node-selected {
            background: transparent;
          }
        }

        .ant-tree-child-tree {
          background: #fff;
        }
        li {
          position: relative;
          line-height: 3;
          padding-bottom: 0;
        }
      }
      .ant-btn {
        margin-bottom: 8px;
      }
    }

    .icon-panel {
      float: right;
      position: absolute;
      right: 5px;
      top: 0px;

      .anticon-plus,
      .anticon-setting,
      .anticon-edit,
      .anticon-delete {
        margin-left: 5px;
        color: #1890ff;
      }
    }
  }
}
/deep/.ant-tree-treenode-switcher-close  {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 0 4px 0 !important;
  height: auto;
  margin: 0 !important;
}
/deep/.ant-tree-node-content-wrapper-close {
  height: auto;
}
/deep/.ant-tree-treenode-switcher-open {
  padding: 0 !important;
}
/deep/.ant-tree-node-content-wrapper-open {
  margin: 0 !important;
  height: auto;
}
/deep/.ant-tree-node-content-wrapper {
  margin: 0 !important;
  height: auto;
}
/deep/.ant-tree-node-selected {
  height: auto;
}
.content-panel .ant-tree li {
  margin: 0!important;
  padding: 0!important;
  height: auto;
}
.content-panel .ant-tree li .ant-tree-child-tree {
  margin: 0!important;
}
/deep/.ant-tree li {
  margin: 0!important;
  padding: 0!important;
}
.deviceTypeSpin {
  height: calc(100% - 80px);
  overflow: auto;
}
.treeCompanyName {
  font-size: 14px;
  width: calc(100% - 50px);
  white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis
}
</style>
